(() => {
  "use strict";

  const HIDDEN_CLASS = "lux-v5-cart-price-unit-hidden";
  const STUDIO_LINE_CLASS = "lux-v5-cart-price-unit-line";
  const REMOVE_CLASS = "lux-v5-cart-remove";
  const REMOVE_WRAP_CLASS = "lux-v5-cart-remove-wrap";
  const LINE_SELECTORS = [
    ".cart-item",
    "[data-cart-item]",
    "[data-cart-line-item]",
    ".cart__item",
    ".ajaxcart__product",
    ".drawer__cart-item",
    "li[data-line-item]"
  ].join(",");
  const QUANTITY_SELECTORS = [
    "quantity-input",
    "quantity-popover",
    ".quantity",
    ".quantity-selector",
    ".cart__qty",
    ".ajaxcart__qty",
    "[data-quantity-selector]",
    "[data-quantity-controls]"
  ].join(",");

  const isDesignStudioLine = line => {
    const text = String(line.textContent || "").toLowerCase();
    return (
      text.includes("luxworld design studio") ||
      text.includes("double curtain builder v5") ||
      text.includes("luxworld custom-made double curtains") ||
      (text.includes("design studio version") && text.includes("5."))
    );
  };

  const hide = node => {
    if (!node) return;
    node.classList.add(HIDDEN_CLASS);
    node.setAttribute("aria-hidden", "true");
    node.querySelectorAll("button, input, select, a").forEach(control => {
      control.setAttribute("tabindex", "-1");
    });
  };

  const isOneDollar = value =>
    /^(?:a\s*)?\$\s*1(?:\.00)?(?:\s*(?:aud))?$/i.test(String(value || "").trim());

  const hideOneDollarPrice = line => {
    line
      .querySelectorAll(
        ".unit-price, .price, .money, .cart-item__price-wrapper, .product-option, [data-unit-price]"
      )
      .forEach(node => {
        if (isOneDollar(node.textContent)) hide(node);
      });
  };

  const isDesignStudioCartItem = item => {
    const properties = Object.entries(item?.properties || {})
      .map(([key, value]) => `${key} ${value}`)
      .join(" ");
    const text = [item?.title, item?.product_title, item?.variant_title, item?.vendor, properties]
      .join(" ")
      .toLowerCase();
    return (
      text.includes("luxworld design studio") ||
      text.includes("double curtain builder v5") ||
      text.includes("luxworld custom-made double curtains") ||
      (text.includes("design studio version") && text.includes("5."))
    );
  };

  const removeDesignStudioItem = async button => {
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = "Removing…";

    try {
      const root = window.Shopify?.routes?.root || "/";
      const cartResponse = await fetch(`${root}cart.js`, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      });
      if (!cartResponse.ok) throw new Error("Unable to read the cart.");

      const cart = await cartResponse.json();
      const studioItem = cart.items?.find(isDesignStudioCartItem);
      if (!studioItem?.key) throw new Error("Design Studio product was not found in the cart.");

      const changeResponse = await fetch(`${root}cart/change.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ id: studioItem.key, quantity: 0 })
      });
      if (!changeResponse.ok) throw new Error("Shopify could not remove the product.");

      window.location.reload();
    } catch (error) {
      console.error("[LUXWORLD cart polish]", error);
      button.disabled = false;
      button.textContent = originalText;
      window.alert("The Design Studio product could not be removed. Please refresh the cart and try again.");
    }
  };

  const ensureRemoveButton = line => {
    if (document.querySelector(`.${REMOVE_CLASS}`)) return;

    const remove = document.createElement("button");
    remove.className = REMOVE_CLASS;
    remove.type = "button";
    remove.textContent = "Remove";
    remove.setAttribute("aria-label", "Remove LUXWORLD Design Studio product from cart");
    remove.addEventListener("click", () => removeDesignStudioItem(remove));

    const removeWrap = document.createElement("div");
    removeWrap.className = REMOVE_WRAP_CLASS;
    removeWrap.append(remove);

    const orderNote =
      line.querySelector('textarea[name="note"], textarea[name="attributes[note]"]') ||
      document.querySelector('textarea[name="note"], textarea[name="attributes[note]"]');
    if (orderNote) {
      const escapedId = orderNote.id && window.CSS?.escape ? window.CSS.escape(orderNote.id) : "";
      const noteLabel =
        orderNote.closest("label") ||
        (escapedId ? document.querySelector(`label[for="${escapedId}"]`) : null) ||
        Array.from(document.querySelectorAll("label")).find(label =>
          /order\s*note/i.test(String(label.textContent || ""))
        );
      const possibleNoteArea = (noteLabel || orderNote).parentElement;
      const noteAnchor =
        possibleNoteArea &&
        possibleNoteArea !== line &&
        possibleNoteArea.tagName !== "FORM" &&
        possibleNoteArea.contains(orderNote)
          ? possibleNoteArea
          : noteLabel || orderNote;

      if (noteAnchor?.parentNode) {
        noteAnchor.parentNode.insertBefore(removeWrap, noteAnchor);
        return;
      }
    }

    const quantityContainers = Array.from(line.querySelectorAll(QUANTITY_SELECTORS));
    const outerQuantityContainer = quantityContainers.find(container =>
      !quantityContainers.some(other => other !== container && other.contains(container))
    );

    if (outerQuantityContainer?.parentNode) {
      outerQuantityContainer.insertAdjacentElement("afterend", removeWrap);
      return;
    }

    line.append(removeWrap);
  };

  const polishLine = line => {
    if (!isDesignStudioLine(line)) return;
    line.classList.add(STUDIO_LINE_CLASS);
    ensureRemoveButton(line);
    line.querySelectorAll(QUANTITY_SELECTORS).forEach(hide);
    line.querySelectorAll('label[for*="Quantity" i], label[for*="quantity" i]').forEach(hide);
    hideOneDollarPrice(line);
  };

  const polishCart = root => {
    if (root?.matches?.(LINE_SELECTORS)) polishLine(root);
    root?.querySelectorAll?.(LINE_SELECTORS).forEach(polishLine);
  };

  const style = document.createElement("style");
  style.textContent = `
    .${HIDDEN_CLASS} {
      display: none !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }
    .${STUDIO_LINE_CLASS} input[name="updates[]"] {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      white-space: nowrap !important;
    }
    .${REMOVE_WRAP_CLASS} {
      position: relative !important;
      z-index: 10 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      box-sizing: border-box !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 24px 16px 30px !important;
      border: 0 !important;
      background: #000 !important;
      isolation: isolate !important;
    }
    .${REMOVE_CLASS} {
      position: relative !important;
      z-index: 11 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      box-sizing: border-box !important;
      width: min(220px, calc(100% - 32px)) !important;
      min-height: 48px !important;
      margin: 0 auto !important;
      padding: 12px 22px !important;
      border: 1px solid #d9aa32 !important;
      border-radius: 8px !important;
      background: #151515 !important;
      color: #d9aa32 !important;
      font: inherit !important;
      font-weight: 700 !important;
      line-height: 1 !important;
      text-decoration: none !important;
      visibility: visible !important;
      pointer-events: auto !important;
      cursor: pointer !important;
      transform: none !important;
      appearance: none !important;
    }
    .${REMOVE_CLASS}:hover,
    .${REMOVE_CLASS}:focus-visible {
      background: #d9aa32 !important;
      color: #080808 !important;
      text-decoration: none !important;
      outline: 2px solid #f4d989 !important;
      outline-offset: 2px !important;
    }
    .${REMOVE_CLASS}:disabled {
      cursor: wait !important;
      opacity: 0.7 !important;
    }
  `;
  document.head.append(style);

  const observer = new MutationObserver(records => {
    records.forEach(record => {
      record.addedNodes.forEach(node => {
        if (node.nodeType === 1) polishCart(node);
      });
    });
  });

  const initialise = () => {
    polishCart(document);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }
})();
